import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  #resizeObserver;

  connectedCallback() {
    super.connectedCallback();

    this.#resizeObserver = new ResizeObserver(() => this.#prepare());
    this.#resizeObserver.observe(this);
    document.addEventListener('visibilitychange', this.#handleVisibilityChange);
    this.#prepare();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
    super.disconnectedCallback();
  }

  #prepare() {
    const viewport = this.querySelector('.announcement-bar__viewport');
    const track = this.querySelector('.announcement-bar__track');
    const group = this.querySelector('.announcement-bar__marquee-group:not([data-marquee-clone])');

    if (!viewport || !track || !group) return;

    track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

    this.style.setProperty('--announcement-group-width', `${viewport.clientWidth}px`);
    const groupWidth = Math.max(viewport.clientWidth, group.scrollWidth);
    const speedSetting = Number.parseFloat(this.dataset.speed || '5');
    const normalizedSpeed = Math.min(Math.max(speedSetting, 1), 10);
    const pixelsPerSecond = 8 + normalizedSpeed * 13.4;
    const duration = Math.max(groupWidth / pixelsPerSecond, 6);

    this.style.setProperty('--announcement-group-width', `${groupWidth}px`);
    this.style.setProperty('--announcement-duration', `${duration}s`);

    const clone = group.cloneNode(true);
    clone.dataset.marqueeClone = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    track.append(clone);
  }

  #handleVisibilityChange = () => {
    this.toggleAttribute('paused', document.hidden);
  };
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
